import WebAnalytics, { BaseEvent, CustomerType } from '@lendi/analytics-web';
import WebAnalyticsV3 from '@lendi/analytics-web-v3';
import { Type } from '@lendi/lala-react';

import getViewType from '../getViewType';
import { lendiAnalytics } from './analytics';

const PII_KEYWORDS = [
  /name/i,
  /phone/i,
  /mobile/i,
  /email/i,
  /streetName/i,
  /streetNumber/i,
  // address can be manually input, so its format has no regular pattern
  /address.formatted/i,
  /^companies$/i,
  /financialInstitutionAccountNumber/i,
  /financialInstitutionBsb/i,
  /comments/i,
];

export const PII_MASK = '*PII_Masked*';
export const maskPIISegmentTracking = (field: string, value: string) => {
  if (!value) {
    return value;
  }

  if (PII_KEYWORDS.some((keyword) => keyword.test(field))) {
    return PII_MASK;
  } else {
    return value;
  }
};

// Base event
export function eventTracking<T extends BaseEvent & { skip?: boolean }>(
  analytics: ReturnType<typeof lendiAnalytics>,
  trackingEvent: T
) {
  const { skip, ...originTrackingEvent } = trackingEvent;
  if (skip) return; // For skipping tracking
  const customerType = getViewType() === Type.Team ? CustomerType.TEAM : CustomerType.CUSTOMER;
  if (analytics instanceof WebAnalyticsV3) {
    analytics.trackEvent({
      ...originTrackingEvent,
      customerType,
    });
    return;
  } else {
    analytics.trackEvent({
      ...originTrackingEvent,
      customerType,
    });
  }
}
